import { Injectable } from "@angular/core";

import { MapperInterface } from "./mapper-inteface";
import { ContoCapienzaDTO } from "../dto/conto-capienzaDTO";
import { ContoCapienzaVO } from "../vo/conto-capienzaVO";
import { MapperConto } from "./mapper-conto";

@Injectable({ providedIn: "root" })
export class MapperContoCapienza
  implements MapperInterface<ContoCapienzaDTO, ContoCapienzaVO> {
  constructor(private contiMapper: MapperConto) {}

  convertVoToDto(contoCapienzaVO: ContoCapienzaVO): ContoCapienzaDTO {
    if (contoCapienzaVO != null) {
      // console.log("[MapperSettore] contocapienzaVO => contocapienzaDTO", contocapienzaVO);
      const contoCapienzaDTO = new ContoCapienzaDTO();

      contoCapienzaDTO.conti = this.contiMapper.convertListVoToDto(
        contoCapienzaVO.conti
      );
      contoCapienzaDTO.esercizio = contoCapienzaVO.esercizio;
      contoCapienzaDTO.periodo = contoCapienzaVO.periodo;

      // console.log("return", contocapienzaDTO);
      return contoCapienzaDTO || new ContoCapienzaDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(contoCapienzaDTO: ContoCapienzaDTO): ContoCapienzaVO {
    if (contoCapienzaDTO != null) {
      // console.log("[MapperSettore] contocapienzaVO => contocapienzaDTO", contocapienzaVO);
      const contoCapienzaVO = new ContoCapienzaVO();

      contoCapienzaVO.conti = this.contiMapper.convertListDtoToVo(
        contoCapienzaDTO.conti
      );
      contoCapienzaVO.esercizio = contoCapienzaDTO.esercizio;
      contoCapienzaVO.periodo = contoCapienzaDTO.periodo;

      // console.log("return", contocapienzaDTO);
      return contoCapienzaVO || new ContoCapienzaVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(
    contocapienzaVOList: ContoCapienzaVO[]
  ): ContoCapienzaDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const contocapienzaDTOList = new Array<ContoCapienzaDTO>();
    contocapienzaVOList.forEach((vo) => {
      contocapienzaDTOList.push(this.convertVoToDto(vo));
    });

    return contocapienzaDTOList || new Array<ContoCapienzaDTO>();
  }

  convertListDtoToVo(
    contocapienzaDTOList: ContoCapienzaDTO[]
  ): ContoCapienzaVO[] {
    // console.log("contocapienzaDTOList", contocapienzaDTOList);
    const contocapienzaVOList = new Array<ContoCapienzaVO>();
    contocapienzaDTOList.forEach((dto) => {
      contocapienzaVOList.push(this.convertDtoToVo(dto));
    });

    return contocapienzaVOList || new Array<ContoCapienzaVO>();
  }
}
